<app-side-menu>
  <div class="portal-hub-content">
    <div class="page-header">
      <h1 class="page-title">
        <i class="fas fa-user-shield me-3"></i>
        Usuários do portal B2B
      </h1>
      <p class="page-subtitle">
        Selecione o contrato para cadastrar usuários e atribuir acessos da Dashboard B2B.
      </p>
    </div>

    <div class="card-panel">
      <app-table
        [title]="'Contratos (' + totalItems + ')'"
        [data]="contracts"
        [columns]="columns"
        [loading]="isLoading"
        [clickable]="false"
        [actions]="actions"
        [showSearch]="true"
        [searchPlaceholder]="'Pesquisar contrato, empresa...'"
        [itemsPerPage]="pageSize"
        [totalItemsFromBackend]="totalItems"
        [currentPageFromBackend]="pageNumber"
        [totalPagesFromBackend]="totalPages"
        [disablePagination]="false"
        (searchChange)="onSearchChange($event)"
        (actionClick)="onActionClick($event)"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)">
      </app-table>
    </div>
  </div>
</app-side-menu>
